import React, { useEffect } from 'react';
import { Phone } from 'lucide-react';
import { businessInfo } from '../mock';

export const FloatingCallButton = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <a
      href={`tel:${businessInfo.phone}`}
      className={`fixed bottom-6 right-6 z-40 md:hidden transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16'
      }`}
    >
      <div className="w-16 h-16 rounded-full flex items-center justify-center shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110 group" style={{ backgroundColor: '#1c2536' }}>
        <Phone className="w-7 h-7 text-white group-hover:rotate-12 transition-transform" />
      </div>
      <div className="absolute -top-2 -right-2 w-5 h-5 bg-green-500 rounded-full border-2 border-white animate-pulse"></div>
    </a>
  );
};
